export default __webpack_public_path__ + "static/Holden-12ff5310781c3d6275156abc878f0d0a.jpg";